var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStakeholders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3332 23.5V21.8333C22.3332 20.9493 21.982 20.1014 21.3569 19.4763C20.7317 18.8512 19.8839 18.5 18.9998 18.5H13.9998C13.1158 18.5 12.2679 18.8512 11.6428 19.4763C11.0177 20.1014 10.6665 20.9493 10.6665 21.8333V23.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 15.1667C18.3408 15.1667 19.8332 13.6743 19.8332 11.8333C19.8332 9.99238 18.3408 8.5 16.4998 8.5C14.6589 8.5 13.1665 9.99238 13.1665 11.8333C13.1665 13.6743 14.6589 15.1667 16.4998 15.1667Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStakeholders);
export default __webpack_public_path__ + "static/media/IconStakeholders.d54ddb98366903347103e47d07f04365.svg";
export { ForwardRef as ReactComponent };